<template>
  <div class="sssss">
    <div style="margin-bottom: 10px;" ref="drawer">
      <span v-for="ind in len" :key="ind">{{overseasFlag == 1 ? (marterArr[ind-1].aliasName || marterArr[ind-1].name) : marterArr[ind-1].name}}{{ind !== len ? '，' : ''}}</span>
      <a style="margin-left: 10px;" v-if="marterArr && marterArr.length > 5 && allName" @click="() => allName = !allName">展开共{{marterArr.length}}项<a-icon style="margin-left: 5px;" type="down" /></a>
      <a style="margin-left: 10px;" v-if="marterArr && marterArr.length > 5 && !allName" @click="() => allName = !allName">收起<a-icon style="margin-left: 5px;" type="up" /></a>
    </div>
    <div style="margin-bottom: 20px;">
      <a-input-search v-model="name" placeholder="请输入指标名称/代码" style="width: 200px;margin-right: 20px;" @search="onSearch" />
      <select-cascader-view
        changeOnSelect
        v-model="cascaderType"
        style="width: 200px"
        category="nutritiontarget"
        @changeVal='cascaderSelect'
      />
        <!-- @change="typeChange" -->
      <a-button @click="onSearch" type="primary" style="margin: 0 10px;">查询</a-button>
      <a-button @click="reset">清空</a-button>
    </div>
    <a-table
      :row-selection="rowSelection"
      :columns="columns"
      :data-source="list"
      row-key="id"
      :pagination="pagination"
      :scroll="{y}"
    />
    <div class="footer">
      <span class="count">已选中 <span class="colorRed">{{this.selectedRowKeys.length || 0}}</span> 个指标</span>
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" @click="next">下一步</a-button>
    </div>
  </div>
</template>

<script>
import SelectCascaderView from './SelectCascaderView'
import { mapMutations,mapState } from 'vuex'
let pageSizeC = 40
export default {
  components:{SelectCascaderView},
  data(){
    return{
      cascaderType:[],
      y: 200,
      name: '',
      columns:[
        {title: '指标名称',dataIndex: 'name'},
        {title: '代码',dataIndex: 'code'},
        {title: '类型',dataIndex: 'typeName',},
      ],
      list: [],
      typeId: null,
      allName: true,
      pagination: {
        total:0,
        pageSize: pageSizeC,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      selectedRowKeys:[],
      selectedRows: []
    }
  },
  computed:{
    ...mapState('material',['marterArr']),
    len(){
      let num = 0
      if(this.marterArr && this.marterArr.length > 5){
        if(!this.allName){ 
          num = this.marterArr.length
        }else{
          num = 5
        }
      }else{
        num = this.marterArr ? this.marterArr.length : 0
      }
      return num
    },
    rowSelection(){
      return {
        // onChange: (selectedRowKeys,selectedRows) => {
        //     this.selectedRowKeys = selectedRowKeys
        //     selectedRows.forEach(el => {
        //       if(this.selectedRows.filter(item => item.id === el.id).length === 0) this.selectedRows.push(el)
        //     })
        //     this.selectedRows = this.selectedRows.filter(el => this.selectedRowKeys.includes(el.id))
        // },
        selectedRowKeys: this.selectedRowKeys,
        onSelect: (record, selected) => {
          if(selected){
            this.selectedRowKeys.push(record.id)
            this.selectedRows.push(record)
          }else{
            this.selectedRowKeys = this.selectedRowKeys.filter(el => el !== record.id)
            this.selectedRows = this.selectedRows.filter(el => el.id !== record.id)
          }
          this.list = [...this.list]
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          if(selected){
            changeRows.forEach(el => {
              if(this.selectedRowKeys.length < 20 && !this.selectedRowKeys.includes(el.id)){
                this.selectedRowKeys.push(el.id)
                this.selectedRows.push(el)
              }
            })
          }else{
            let ids = changeRows.map(el => el.id)
            this.selectedRowKeys = this.selectedRowKeys.filter(el => !ids.includes(el))
            this.selectedRows = this.selectedRows.filter(el => this.selectedRowKeys.includes(el.id))
          }
          this.list = [...this.list]
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.isAutoCal === 1 || (this.selectedRows.length >= 20 && !this.selectedRowKeys.includes(record.id))
          },
        }),
      }
    }
  },
  created(){
    this.getList()
  },
  mounted(){
    let clientHeight = document.body.clientHeight || document.documentElement.clientHeight
    this.y = clientHeight - 260 - (this.$refs.drawer.clientHeight || 0)
  },
  methods:{
    ...mapMutations('material',['setState']),
    cascaderSelect(val){
      this.cascaderType = val
    },
    cancel(){
      this.setState({steps: 0,codeArr:[],selectedList:[],selectedRowKeys:[],marterArr:[],visible: false})
    },
    next(){
      if(this.selectedRowKeys.length === 0){
        this.$message.warning('请选择指标')
        return
      }
      let codeArr = []
      this.selectedRows.forEach(el => {
        codeArr.push(el.code)
      })
      this.setState({codeArr,selectedList:this.selectedRows,steps: 1,selectedRowKeys: this.selectedRowKeys})
      
      // this.columns2 = this.getColumns2()
      // this.modalShow2()
      // this.getList2()
    },
    typeChange(typeId){
      this.typeId = typeId
      this.getList({current: 1,pageSize: pageSizeC,typeId})
    },
    onSearch(){
      this.getList({current: 1,pageSize: pageSizeC})
    },
    reset(){
      this.cascaderType = []
      this.typeId = null
      this.name = null
    },
    getList(pagination){
      let {current,typeId,pageSize} = pagination || this.pagination
      let params = {
        size: pageSize,
        current,
        keyword: this.name,
        typeId: this.typeId
      }
      if(typeId) params.typeId = typeId
      // /nhf-app/factorystaffnutritionraw/selectNutritionWithoutSpecialTypePage
      this.$http.get('/nhf-app/factorystaffnutritionraw/selectNutritionWithoutSpecialTypePage',{params}).then(res => {
        let {success,data} = res || {}
        if(success){
          let {records,current=1,total=0,size=pageSizeC} = data;
            this.pagination.current = current
            this.pagination.pageSize = size
            this.pagination.total = total
            this.list = records || []
        }
      })
    },
  }
}
</script>
